// Filtres partages des sous-vues "Usage" et "Statistiques" de la page Usage des vues (BI-693).
import moment from "moment";
import React from "react";
import { DatePicker, Select } from "antd";

import { lireEnv } from "./usageVuesFormat";

export const FMT = "YYYY-MM-DD";
export const periodeDefaut = () => [moment().subtract(30, "days"), moment()];

// Parametres d'API communs a /api/usage/views et /api/usage/stats (null si periode incomplete).
export function construireParams(periode, env, module) {
  if (!periode || !periode[0] || !periode[1]) return null;
  const params = { from: periode[0].format(FMT), to: periode[1].format(FMT) };
  if (env) Object.assign(params, lireEnv(env));
  if (module) params.module = module;
  return params;
}

export default function UsageFiltres({ periode, setPeriode, env, setEnv, module, setModule, envs, modules }) {
  return (
    <div className="usage-filtres" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
      <DatePicker.RangePicker
        aria-label="Période"
        value={periode}
        format="DD/MM/YYYY"
        allowClear={false}
        onChange={(v) => v && setPeriode(v)}
      />
      <Select
        aria-label="Environnement"
        placeholder="Tous les environnements"
        allowClear
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 260 }}
        value={env}
        onChange={setEnv}
        options={envs.map((e) => ({ value: e.cle, label: e.label }))}
      />
      <Select
        aria-label="Module"
        placeholder="Tous les modules"
        allowClear
        style={{ minWidth: 180 }}
        value={module}
        onChange={setModule}
        options={modules.map((m) => ({ value: m.code, label: m.label }))}
      />
    </div>
  );
}
